import styled from "styled-components";

// Conservés pour les anciennes listes (formulaires simplifiés, renouvellements PJ).
export const StyledLeadItem = styled.div`
  margin-top: 40px;
`;

export const StyledCountBadge = styled.span`
  background: ${({ disabled }) => (disabled ? `#cacaca` : `var(--primary)`)};
  color: white;
  padding: 0px 3px;
  font-weight: 600;
  font-style: normal;
  border-radius: 5px;
  min-width: 15px;
  display: inline-block;
  text-align: center;
  font-size: 11px;
`;
